<div class="headerFlexW pr-4 m-3">
  <div class="content-block">
    <p class="bread-crumbs">Atención a Clientes</p>
    <h2 class="">Atención a Clientes</h2>
  </div>
</div>

<div class="content-block">
  <div class="dx-card responsive-paddings">
    <!-- Results -->

    <!-- icons -->
    <div class="flex flex-end flex-items-center font-size-20 data-grid-icons">
      <span><i class="far fa-exclamation-circle status-4"></i> Nuevo</span>
      <!--<i class="fa fa-comment-exclamation status-1"></i>-->
      <span><i class="far fa-comment-dots status-3"></i>Atendiendo</span>
      <!--<i class="fa fa-check status-3"></i>-->
      <span><i class="fa fa-check status-3"></i>Cerrado Soporte</span>
      <span><i class="fa fa-check-double status-3"></i>Cerrado Usuario</span>
      <span><i class="fa fa-folder-open status-4"></i>Reabierto</span>
    </div>

    <br>

    <!-- table -->
    <div class="">
      <dx-data-grid [dataSource]="notes" keyExpr="idNote" [showBorders]="true" [columnAutoWidth]="true" class="notesGrid">
        <dxo-load-panel [enabled]="true"></dxo-load-panel>
        <dxo-paging [pageSize]="10"></dxo-paging>
        <dxo-pager [showPageSizeSelector]="true" [allowedPageSizes]="[5, 10, 25, 50, 100]" [showInfo]="true"></dxo-pager>
        
        <!-- <dxi-column dataField="dateCreated" caption="Creada" cellTemplate="dateTemplate" alignment="center">
        </dxi-column> -->
        <dxi-column dataField="idNote" caption="No." dataType="number" alignment="center"></dxi-column>
        <!--<dxi-column dataField="userName" caption="Usuario"  alignment="left" ></dxi-column>-->
        <dxi-column dataField="email" caption="Usuario"  alignment="left" ></dxi-column>
        <dxi-column dataField="note" caption="Mensaje" alignment="left" cssClass="wordWrap" width="200"></dxi-column>
        <dxi-column dataField="dateCreated" caption="Fecha Ingreso" dataType="date" format="dd/MM/yyyy hh:mm a" alignment="center"></dxi-column>
        <dxi-column dataField="status" caption="Estatus" cellTemplate="statusCellTemplate" alignment="center" >
          
        </dxi-column>
        <dxi-column type="buttons">
          <dxi-button template="btnDetailTemplate">
            <div *dxTemplate="let data of 'btnDetailTemplate'">
              <a routerLink="detail/{{data.data.idNote}}" (click)="goToDetail(data)"><i class="fad fa-comments" style="font-size: 25px;"></i></a>
            </div>
          </dxi-button>
        </dxi-column>

        <div *dxTemplate="let data of 'statusCellTemplate'" class="status-icon">
          <i *ngIf="data.value === 1" class="far fa-exclamation-circle status-4"></i>
          <!--<i *ngIf="data.value === 2" class="fa fa-comment-exclamation status-1"></i>-->
          <i *ngIf="data.value === 3" class="far fa-comment-dots status-3"></i>
          <!--<i *ngIf="data.value === 4" class="fa fa-check status-3"></i>-->
          <i *ngIf="data.value === 5" class="fa fa-check status-3"></i>
          <i *ngIf="data.value === 6" class="fa fa-check-double status-3"></i>
          <i *ngIf="data.value === 7" class="fa fa-folder-open status-4"></i>
          <!--
          <dx-drop-down-button
            [items]="statusList"
            displayExpr="name"
            keyExpr="idNoteStatus"
            [selectedItemKey]="data.value"
            [dropDownOptions]="{ width: '200px' }"
            [useSelectMode]="true"
            (onItemClick)="onSelectStatus($event,data)"
          ></dx-drop-down-button>
          -->
        </div>
        <!--
        <div *dxTemplate="let data of 'TarjetaTemplate'">
          <i class="far fa-credit-card mr-2"></i>
          <span>**** **** **** {{data.value}}</span>
        </div>
        -->
      </dx-data-grid>
    </div>
  </div>
</div>